import { EventEmitter } from "events";

export type SubscriptionStateType = "connected" | "disconnected";

declare interface SubscriptionEventsEmitter {
  on(
    event: "subscriptionStateChange" | "chatRoomSubscriptionStateChange",
    listener: (payload: {
      channel: string;
      subscriptionState: SubscriptionStateType;
    }) => any,
  ): this;
}

class SubscriptionEventsEmitter extends EventEmitter {
  constructor() {
    super();
  }

  emitSubscriptionStateChange = (payload: {
    channel: string;
    subscriptionState: SubscriptionStateType;
  }) => {
    if (payload.channel === "Chats::RoomChannel") {
      this.emit("chatRoomSubscriptionStateChange", payload);
    } else {
      this.emit("subscriptionStateChange", payload);
    }
  };
}

export const subscriptionEventsEmitter = new SubscriptionEventsEmitter();
